export default __webpack_public_path__ + "static/media/placeMarker.5182feae.svg";